import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import { RouteSegments } from '@cbridge-packages/routing-client-admin';
import { UserSettingsSection } from '@cbridge-packages/user-settings';
import { SidebarNavigationDrawer } from '@cbridge-modules/sidebar';
import { DashboardsSidebarFooter } from '@cbridge-fragments/dashboards/src/layout/DashboardsSidebarFooter';
import { useRiskManagementNavigation } from '../_navigation/useRiskManagementNavigation';

export const RiskManagementLayout: FunctionComponent = () => {
  const navigation = useRiskManagementNavigation();

  return (
    <>
      <SidebarNavigationDrawer
        defaultSidebarCollapsed={true}
        isCollapsible={true}
        settingsKey={UserSettingsSection.RiskManagement}
        isResizable={true}
        navigation={navigation}
        navigationBasePath={`/${RouteSegments.Root.RiskManagement}`}
        slots={{
          sidebarFooter: DashboardsSidebarFooter,
        }}
      />

      <Outlet />
    </>
  );
};
